import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const ProductAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHaveProductAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            product: {
              isHaveAddAccess: true,
              isHaveImportAccess: true,
              isHaveExportAccess: true,
              isHaveBarcodePrintAccess: true,
              isHaveEditAccess: true,
              isHaveDeleteAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            product: {
              isHaveAddAccess: false,
              isHaveImportAccess: false,
              isHaveExportAccess: false,
              isHaveBarcodePrintAccess: false,
              isHaveEditAccess: false,
              isHaveDeleteAccess: false,
            },
          }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHaveProductAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      product: { ...j.product, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHaveProductAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveImportAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveImportAccess) ||
            false
          }
          name={"isHaveImportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveBarcodePrintAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveBarcodePrintAccess) ||
            false
          }
          name={"isHaveBarcodePrintAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.product &&
              featuresAccess.product.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default ProductAccess;
